<template>
  <div class="content">
    <span>Bạn có công việc</span>
    <span class="highlight font-weight__bold"> {{ taskTitle }} </span>
    <span :class="['highlight-action', remainingDay >= 0 ? 'warning' : 'alert']">
      {{ state }}
    </span>
  </div>
</template>

<script>
  import errorMessageFilter from "../../filters/errorMessageFilter";

  export default {
    name: "notification-item-quahan-cv",
    props: ["vbNotificationView"],
    data() {
      return {
        taskTitle: null,
        state: null,
        remainingDay: null,
        dataJson: null
      };
    },
    created() {
      this.initData();
    },
    methods: {
      initData() {
        this.dataJson = JSON.parse(this.vbNotificationView.dataJson);
        this.taskTitle = this.dataJson.tkTask.taskTitle;
        this.remainingDay = this.dataJson.remainingDay;
        this.state =
          this.remainingDay >= 0
            ? errorMessageFilter({
              errorCode: "canhBaoQuaHan.toiHan.label",
              params: [this.remainingDay]
            })
            : errorMessageFilter({
              errorCode: "canhBaoQuaHan.quaHan.label",
              params: [Math.abs(this.remainingDay)]
            });
      }
    }
  };
</script>

<style scoped>
  .highlight-action.warning {
    color: orange !important;
  }

  .highlight-action.alert {
    color: red !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/header/notification-item-quahan-cv.vue